import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { QRCodeSVG } from "qrcode.react";
import "./PlaidQrVerificationModal.scss";

const PLAID_QR_COLOR = "#2563EB";

const PlaidQrVerificationModal = ({
  show,
  shareableUrl,
  acceptTosSuccess,
  onClose,
  onCancel,
}) => {
  const heading = acceptTosSuccess
    ? "Verification is currently in progress on you mobile device."
    : "Scan this code with your phone\u2019s camera";
  const description = acceptTosSuccess
    ? "Continue verification on your mobile device or Scan QR code to resume verification."
    : "Use the QR code to complete this verification on your mobile device.";

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      className="[ popup-modal__container plaid-qr-verification-modal ]"
      aria-labelledby="plaid-qr-verification-title"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header
        className="[ popup-modal__header plaid-qr-verification-modal__header ]"
        closeButton={false}
      >
        <Modal.Title
          id="plaid-qr-verification-title"
          className="plaid-qr-verification-modal__title"
        >
          ID Verification
        </Modal.Title>
      </Modal.Header>
      <div
        className="plaid-qr-verification-modal__progress"
        role="progressbar"
        aria-valuenow={60}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div className="plaid-qr-verification-modal__progress-bar" />
      </div>
      <Modal.Body className="plaid-qr-verification-modal__body">
        <h2 className="plaid-qr-verification-modal__heading">{heading}</h2>
        <p className="plaid-qr-verification-modal__description">
          {description}
        </p>
        <div className="plaid-qr-verification-modal__qr-wrap">
          {shareableUrl && (
            <QRCodeSVG
              value={shareableUrl}
              size={220}
              level="M"
              fgColor={PLAID_QR_COLOR}
              bgColor="#ffffff"
            />
          )}
        </div>
        <div className="plaid-qr-verification-modal__actions">
          <p className="plaid-qr-verification-modal__cancel-hint">
            Cancelling your ID verification will mean you will need to restart
            the process again at a later time.
          </p>
          <button
            type="button"
            className="[ btn ] [ tertiary-btn ] [ w-100 ] plaid-qr-verification-modal__cancel-btn"
            onClick={handleCancel}
          >
            <span className="[ btn-text ]">Cancel</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

PlaidQrVerificationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  shareableUrl: PropTypes.string,
  acceptTosSuccess: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default PlaidQrVerificationModal;
